const convertToCurrency = (currency: string, amount: number) => {
  return amount < 0
    ? "-" +
        currency +
        Math.abs(amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
    : currency +
        amount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
};

export default convertToCurrency;
